<template>
  <section v-if="data.acf_fields && !isUserAuth" :class="$style.addFavorites">
    <div :class="$style.addFavorites__wrapper">
      <IconStar />
      <p>
        {{ data.acf_fields.form_title }}
        <button @click="openNewsletter" :class="$style.addFavorites__link" hreflang="en">
          {{ data.acf_fields.url_txt }}
        </button>
      </p>
      <IconStar />
    </div>
  </section>
</template>

<script lang="ts" setup>
import IconStar from '~/assets/icons/icon-star.vue'

const userStore = useUserStore()
const isUserAuth = computed(() => userStore.user.info.email !== null)
const router = useRouter()

function openNewsletter(): void {
  router.push('/club')
}

defineProps<{
  data: {
    acf_fields: {
      form_title: string
      url_txt: string
    }
  }
}>()
</script>

<style lang="scss" module>
.addFavorites {
  margin: var(--gutter-desktop) auto 0;

  &__wrapper {
    border-radius: 0.625rem;
    background-color: v.$color-black;
    padding: 1.5625rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
    color: v.$color-white;
    text-align: center;

    p {
      @include t.text-announcement;
      width: fit-content;
    }
  }

  &__link {
    background-color: transparent;
    border: none;
    color: v.$color-white;
    text-decoration: underline;
    transition: 0.15s;

    &:hover {
      color: v.$color-light-grey;
      cursor: pointer;
    }
  }

  @include v.to(mobile) {
    margin: var(--gutter-mobile) auto 0;

    &__wrapper {
      padding: 1.25rem 1.875rem;
      justify-content: space-between;

      p {
        @include t.text-question;
      }
    }
  }
}
</style>
